<template>
  <div>
    <template v-if="feedstyle == 'news'">
      <dl v-for="item in items" :key="item.id">
        <dt>{{ dateConv(item.date) }}</dt>
        <dd>
          <a :href="item.link">{{ item.title.rendered }}</a>
        </dd>
      </dl>
    </template>
    <template v-else-if="feedstyle == 'news-style01'">
      <dl v-for="item in items" :key="item.id">
        <dt>{{ dateConv(item.date) }}<span class="news_tag">NEW</span></dt>
        <dd>
          <a :href="item.link">{{ item.title.rendered }}</a>
        </dd>
      </dl>
    </template>
    <template v-else-if="feedstyle == 'blog'">
      <div :class="childClass" v-for="item in items" :key="item.id">
        <a :href="item.link">
          <div class="img_box" v-if="getThumb">
            <span v-if="item.thumbnail"
              ><img :src="item.thumbnail" alt="item.title.rendered"
            /></span>
            <span v-else><img :src="noImage" alt="no image" /></span>
          </div>
          <div class="txt_box">
            <p v-if="getDate && flameType === 'A'" class="date">
              {{ dateConv(item.date) }}
            </p>
            <h3 :class="h3Class">{{ item.title.rendered }}</h3>
            <div v-if="getExcerpt">{{ strReplace(item.excerpt.rendered) }}</div>
            <p v-if="getDate && flameType === 'B'" class="date">
              {{ dateConv(item.date) }}
            </p>
          </div>
        </a>
      </div>
    </template>
    <template v-else-if="feedstyle == 'column-style01'">
      <div class="column_box column" v-for="item in items" :key="item.id">
        <a :href="item.link">
          <div class="img_wrap">
            <img
              :src="item.thumbnail || noImage"
              :alt="item.title.rendered"
            />
          </div>
          <div class="cont_wrap">
            <div class="post_info_box">
              <time class="date">{{ dateConv(item.date) }}</time>
              <div class="cat_tag_box" v-if="getTaxonomyTerms(item).length > 0">
                <span class="tag_cat" v-for="term in getTaxonomyTerms(item)" :key="term">
                  {{ term }}
                </span>
              </div>
            </div>
            <h3 class="ttl">{{ item.title.rendered }}</h3>
          </div>
        </a>
      </div>
    </template>
    <template v-else>
      <aside class="news_ticker">
        <div v-for="item in items" :key="item.id">
          <template v-if="item.acf.linktype == '1'">
            <a :href="item.link" class="post">
              <div class="container">
                <h2>
                  {{ item.title.rendered }}
                </h2>
              </div>
            </a>
          </template>
          <template
            v-else-if="item.acf.linktype == '2' && item.acf.linkurl != ''"
          >
            <a :href="item.acf.linkurl" class="linkurl">
              <div class="container">
                <h2>
                  {{ item.title.rendered }}
                </h2>
              </div>
            </a>
          </template>
          <template v-else>
            <div class="container">
              <h2>
                {{ item.title.rendered }}
              </h2>
            </div>
          </template>
        </div>
      </aside>
    </template>
    <div class="spinner_area">
      <pulse-loader
        :loading="isLoading"
        :color="'#0693e3'"
        :size="'10px'"
      ></pulse-loader>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      isLoading: false,
    };
  },
  props: {
    url: String,
    dateformat: String,
    feedstyle: {
      type: String,
      default: "blog",
    },
    getThumb: {
      type: Boolean,
      default: false,
    },
    thumbSize: {
      type: String,
      default: "thumbnail",
    },
    getExcerpt: {
      type: Boolean,
      default: false,
    },
    getDate: {
      type: Boolean,
      default: true,
    },
    flameType: {
      type: String,
      default: "A",
    },
    childClass: {
      type: String,
      default: "",
    },
    h3Class: {
      type: String,
      default: "",
    },
    noImage: {
      type: String,
      default: "/assets/img/common/no_image.png",
    },
  },
  methods: {
    getPosts() {
      this.isLoading = true;
      var self = this;
      axios
        .get(this.url)
        // Success
        .then((response) => {
          if (response.status != 200) {
            console.log(response.statusText);
            exit;
          }
          self.items = response.data;
          //サムネイルの取得とデータ格納
          if (self.getThumb) {
            for (let i = 0; i < self.items.length; i++) {
              if (response.data[i]["_embedded"] != 'undefined') {
                const target =
                  "_embedded.wp:featuredmedia.0.media_details.sizes." +
                  self.thumbSize +
                  ".source_url";
                if (this.objectLookUp(response.data[i], target)) {
                  if (
                    response.data[i]["_embedded"]["wp:featuredmedia"][0][
                      "media_details"
                    ]["sizes"][self.thumbSize]["source_url"]
                  ) {
                    self.items[i].thumbnail =
                      response.data[i]["_embedded"]["wp:featuredmedia"][0][
                        "media_details"
                      ]["sizes"][self.thumbSize]["source_url"];
                  }
                }
              }
            }
          }
          this.isLoading = false;
        })
        // Error
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    dateConv(data) {
      var newdate = new Date(data);
      var year = newdate.getFullYear();
      var month = newdate.getMonth() + 1; 
      var day = newdate.getDate(); 

      if (this.dateformat == "dots") {
        // dots の場合のみゼロ埋め
        month = month.toString().padStart(2, '0');
        day = day.toString().padStart(2, '0');
        return year + '.' + month + '.' + day;
      } else {
        return year + '年' + month + '月' + day + '日';
      }
    },
    strReplace(data) {
      //…[&hellip;]
      var replaced = data.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, "");
      replaced = replaced.replace(/ \[&hellip;\]/g, "…");
      //console.log(replaced);
      return replaced;
    },
    objectLookUp(obj, path) {
      const keys = path.split(".");
      for (let k in keys) {
        const key = keys[k];

        if (!obj.hasOwnProperty(key)) {
          return false;
        }

        if (keys.length > 1) {
          return this.objectLookUp(obj[key], keys.splice(1).join("."));
        }
        return true;
      }
    },
    getTaxonomyTerms(item) {
      if (
        item._embedded &&
        item._embedded['wp:term'] &&
        item._embedded['wp:term'][0] &&
        item._embedded['wp:term'][0].length > 0
      ) {
        // "column-cat" タクソノミーのすべてのタームを配列で返す
        return item._embedded['wp:term'][0]
          .filter(t => t.taxonomy === 'column-cat')
          .map(t => t.name);
      }
      return []; // タームがない場合は空配列
    },
  },
  created() {
    this.getPosts();
  },
};
</script>